/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdDomainSettingsLinksOptions interface.
 */
export function instanceOfFxIdDomainSettingsLinksOptions(value) {
    return true;
}
export function FxIdDomainSettingsLinksOptionsFromJSON(json) {
    return FxIdDomainSettingsLinksOptionsFromJSONTyped(json, false);
}
export function FxIdDomainSettingsLinksOptionsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'DiscordQrCodeImageUrl': json['DiscordQrCodeImageUrl'] == null ? undefined : json['DiscordQrCodeImageUrl'],
    };
}
export function FxIdDomainSettingsLinksOptionsToJSON(json) {
    return FxIdDomainSettingsLinksOptionsToJSONTyped(json, false);
}
export function FxIdDomainSettingsLinksOptionsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'DiscordQrCodeImageUrl': value['DiscordQrCodeImageUrl'],
    };
}
//# sourceMappingURL=FxIdDomainSettingsLinksOptions.js.map